module.exports = __webpack_public_path__ + "img/icon_mensageria.096db1c5.svg";